import type { LeaveBalance } from "./types";

/**
 * Which balances get a tile.
 *
 * The company asked for three figures on the employee's pages — annual, sick
 * and overtime — and not a row of tiles for hajj, study and bereavement that
 * most people never touch. HR says which types show, on the type itself; the
 * API still returns every balance, so this is where the rest are left out.
 * Untracked types (unpaid leave) have no figure to draw at all.
 */
export function shownBalances(balances: readonly LeaveBalance[]): LeaveBalance[] {
  return balances.filter((balance) => balance.tracked && balance.shows_balance);
}

/**
 * The same split for an HR reader, who keeps every type but should be able
 * to see which ones the employee is not shown.
 */
export function splitBalances(balances: readonly LeaveBalance[]): {
  shown: LeaveBalance[];
  hidden: LeaveBalance[];
} {
  const tracked = balances.filter((balance) => balance.tracked);
  return {
    shown: tracked.filter((balance) => balance.shows_balance),
    hidden: tracked.filter((balance) => !balance.shows_balance),
  };
}
